var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('h1',[_vm._v("Info")]),(!_vm.loading)?_c('div',[_c('Info')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }